import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, timer } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { ConfigService } from '@bo-client/config/config.service';

@Injectable({ providedIn: 'root' })
export class BuildUpToDateService {
  private buildIsUpToDateSubject = new BehaviorSubject<boolean>(true);
  private buildInfoAtStartup: any;

  constructor(private configService: ConfigService, private httpClient: HttpClient) {
    this.buildInfoAtStartup = this.configService.getSettings('buildInfo');

    this.pollForBuildNumber();
  }

  public get buildIsUpToDate(): Observable<boolean> {
    return this.buildIsUpToDateSubject;
  }

  private pollForBuildNumber() {
    const pollInterval = 60000;

    const httpOptions = {
      headers: new HttpHeaders({
        'Cache-Control': 'no-cache'
      })
    };

    timer(pollInterval, pollInterval).subscribe(() => {
      this.httpClient
        .get<any>('./assets/config.json', httpOptions)
        .toPromise()
        .then((settings) => {
          if (this.buildInfoAtStartup.buildNumber !== settings.buildInfo.buildNumber) {
            this.buildIsUpToDateSubject.next(false);
          }
        });
    });
  }
}
